var $949061cb954e8000$exports = {};
$949061cb954e8000$exports = {
    "close": `Sluiten`,
    "notifications": `Meldingen`
};


export {$949061cb954e8000$exports as default};
//# sourceMappingURL=nl-NL.module.js.map
